import React from 'react';
import { LocalizedMessage } from 'intl/LocalizedComponents';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';
import _size from 'lodash/size';
import _without from 'lodash/without';
import PropTypes from 'prop-types';
// HOCs
import withFormManagement from 'hocs/WithFormManagement';
// Core components
import Card from 'components/core/Card';
import { ContainedButton } from 'components/core/Button';
import { DeleteIconButton } from 'components/buttons/IconButtons';
import Divider from 'components/core/Divider';
import List from 'components/core/List';
import TextField from 'components/core/TextField';
// Models
import { sanitizeDesc } from 'models/accessWay';
// Custom
import FormDialogTemplate from 'components/templates/FormDialogTemplate';
import FormHelper from 'components/misc/FormHelper';
import InformationItem from 'components/items/InformationItem';
import {
  buildFormErrors,
  cpmOnDemandAccessLicensePlateConstraints,
} from 'utils/Forms';

class IgnoredLicensePlateForm extends React.Component {
  constructor(props) {
    super(props);
    const { ignoredLicensePlates } = this.props;

    this.handleAddLicensePlate = this.handleAddLicensePlate.bind(this);
    this.handleDeleteLicensePlate = this.handleDeleteLicensePlate.bind(this);
    this.handleValidate = this.handleValidate.bind(this);

    this.state = {
      newLicensePlatesList: ignoredLicensePlates,
    };
  }

  componentDidMount() {
    // We need to pass component reference to parent (= DialogItem)
    const { onRef } = this.props;
    onRef(this);
  }

  handleAddLicensePlate() {
    const {
      fields: { licensePlate },
      onErrorsChange,
      onFieldsChange,
    } = this.props;

    const errors = buildFormErrors(
      { licensePlate },
      cpmOnDemandAccessLicensePlateConstraints,
    );

    // Apply errors
    onErrorsChange(errors);

    if (!errors) {
      this.setState((state) => ({
        newLicensePlatesList: [...state.newLicensePlatesList, licensePlate],
      }));

      onFieldsChange({
        licensePlate: '',
      });
    }
  }

  handleDeleteLicensePlate(value) {
    this.setState((state) => ({
      newLicensePlatesList: _without(state.newLicensePlatesList, value),
    }));
  }

  // Handlers called by parent (= DialogItem)
  handleValidate() {
    const { onValidate } = this.props;
    const { newLicensePlatesList } = this.state;

    onValidate(newLicensePlatesList);
  }

  render() {
    const {
      fields: { licensePlate },
      onFieldsChange,
      errors,
    } = this.props;
    const { newLicensePlatesList } = this.state;

    return (
      <FormDialogTemplate errors={errors}>
        <div className="row">
          <div className="col-12">
            <Card>
              <div className="row">
                <div className="col-12 pt-3">
                  <div className="d-flex">
                    <FormHelper
                      elements={[
                        {
                          content: (
                            <LocalizedMessage id="help.onDemandSettings.formAddIgnoredLicensePlate" />
                          ),
                        },
                      ]}
                    />
                    <div style={{ flex: 1 }}>
                      <Card>
                        <div className="row">
                          <div className="col-12">
                            <Card padding="dense" outlined>
                              <div className="d-flex align-items-end flex-wrap justify-content-between">
                                <div
                                  style={{ width: 200 }}
                                  className="pl-2 pb-1"
                                >
                                  <TextField
                                    margin="none"
                                    label={
                                      <LocalizedMessage id="field.licensePlate" />
                                    }
                                    value={licensePlate}
                                    errorText={_get(errors, 'licensePlate')}
                                    onEnterPress={this.handleAddLicensePlate}
                                    onChange={(value) => onFieldsChange({
                                      licensePlate: sanitizeDesc(
                                        value,
                                        'license_plate',
                                      ),
                                    })}
                                  />
                                </div>
                                <ContainedButton
                                  label={<LocalizedMessage id="button.add" />}
                                  size="small"
                                  onClick={this.handleAddLicensePlate}
                                />
                              </div>
                            </Card>
                            <div className="pt-3">
                              <Card padding="dense" outlined defaultBackground>
                                <List disablePadding>
                                  {_map(
                                    newLicensePlatesList,
                                    (value, index) => (
                                      <React.Fragment key={index}>
                                        <InformationItem
                                          light
                                          icon="cAwTypeLPlate"
                                          value={value}
                                          rightIcon={(
                                            <DeleteIconButton
                                              size="small"
                                              onClick={() => this.handleDeleteLicensePlate(
                                                value,
                                              )}
                                            />
                                          )}
                                        />
                                        {index
                                          < _size(newLicensePlatesList) - 1 && (
                                          <Divider variant="middle" />
                                        )}
                                      </React.Fragment>
                                    ),
                                  )}
                                  {_isEmpty(newLicensePlatesList) && (
                                    <div className="px-3">
                                      <em>
                                        <LocalizedMessage id="info.useFormAddVehicle" />
                                      </em>
                                    </div>
                                  )}
                                </List>
                              </Card>
                            </div>
                          </div>
                        </div>
                      </Card>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>
        </div>
      </FormDialogTemplate>
    );
  }
}

IgnoredLicensePlateForm.propTypes = {
  ignoredLicensePlates: PropTypes.arrayOf(PropTypes.string).isRequired,
  fields: PropTypes.object.isRequired,
  errors: PropTypes.object,
  onRef: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
  onFieldsChange: PropTypes.func.isRequired,
  onErrorsChange: PropTypes.func.isRequired,
};

IgnoredLicensePlateForm.defaultProps = {
  errors: null,
};

const mapFieldsToProps = {
  licensePlate: {
    defaultValue: '',
  },
};

module.exports = withFormManagement(
  mapFieldsToProps,
  null,
  false,
)(IgnoredLicensePlateForm);



// WEBPACK FOOTER //
// ./routes/cpm/routes/carparks/assets/settings/IgnoredLicensePlateForm.js